import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "ql-bold",
      type: "button"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "ql-italic",
      type: "button"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "ql-underline",
      type: "button"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
    /*#__PURE__*/_createElementVNode("select", { class: "ql-color" }),
    /*#__PURE__*/_createElementVNode("select", { class: "ql-background" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
    /*#__PURE__*/_createElementVNode("select", { class: "ql-align" }, [
      /*#__PURE__*/_createElementVNode("option", { defaultValue: "" }),
      /*#__PURE__*/_createElementVNode("option", { value: "center" }),
      /*#__PURE__*/_createElementVNode("option", { value: "right" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "ql-link",
      type: "button"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "ql-formats" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "ql-clean",
      type: "button"
    })
  ])
], -1)
const _hoisted_2 = {
  key: 0,
  class: "character-counter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editor = _resolveComponent("Editor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Editor, {
      modelValue: _ctx.editableHtml,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.editableHtml = $event)),
      onTextChange: _ctx.onUpdate,
      ref: "editorRef"
    }, {
      toolbar: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["modelValue", "onTextChange"]),
    (_ctx.maxLength && _ctx.textValue !== null)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("b", null, _toDisplayString(_ctx.textValue.length) + " / " + _toDisplayString(_ctx.maxLength), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}